export const style = {
  Divider: {
    sx: {
      pt: 3,
    },
  },
  CardContent: {
    paddingBottom: 0,
  },
  Card: {
    sx: {
      mb: 3,
      width: '100%',
    },
  },
  row: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
} as const;
